import { render, staticRenderFns } from "./NumberMap.vue?vue&type=template&id=b5b99bc6"
import script from "./NumberMap.vue?vue&type=script&lang=js"
export * from "./NumberMap.vue?vue&type=script&lang=js"
import style0 from "./NumberMap.vue?vue&type=style&index=0&id=b5b99bc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports